import styled from "styled-components";

export const CardSecondary = styled.div`
  background-color: var(--theme-color-secondary);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  border-radius: 1rem;
  text-transform: capitalize;
  overflow: hidden;

  h5 {
    font-weight: 400;
    margin: 0;
  }
`;

export const CardSecondaryContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 5px 10px;

  p {
    font-size: 13px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow-wrap: break-word;
    font-style: italic;

    strong {
      font-weight: bold;
    }
  }
`;